function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var ScrollLock = /*#__PURE__*/function () {
  function ScrollLock() {
    _classCallCheck(this, ScrollLock);

    this.currentPos = 0;
    this.tag = null;
    this.head = document.head;
  }

  _createClass(ScrollLock, [{
    key: "getCurrentPos",
    value: function getCurrentPos() {
      return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    }
  }, {
    key: "createStyleTag",
    value: function createStyleTag() {
      var css = "\n      body {\n        overflow: hidden !important;\n        position: fixed;\n        top: -".concat(this.currentPos, "px;\n        left: 0;\n        width: 100%;\n      }\n    ");
      var tag = document.createElement('style');
      tag.type = 'text/css';
      tag.setAttribute('data-react-scrolllock', '');
      tag.appendChild(document.createTextNode(css));
      this.head.appendChild(tag);
      this.tag = tag;
    }
  }, {
    key: "on",
    value: function on() {
      if (!this.head) return;
      this.currentPos = this.getCurrentPos();
      this.createStyleTag();
    }
  }, {
    key: "off",
    value: function off() {
      if (!this.tag) return;
      this.head.removeChild(this.tag);
      this.tag = null;
      window.scrollTo(0, this.currentPos);
    }
  }]);

  return ScrollLock;
}();

export { ScrollLock as default };